import { COUNTRY_MESSAGES } from 'mk2/apps/strollers/components/features/constants';
import { Features } from 'mk2/apps/strollers/schemas';
import { niceSortInPlace } from 'mk2/apps/strollers/utils';
import React from 'react';
import styles from './CountriesFeature.mscss';

interface OwnProps {
    features: Features;
    feature: any;
}

type Props = OwnProps;

export class CountriesFeature extends React.Component<Props> {
    public render() {
        const { feature, features } = this.props;

        const arrValue = feature.rawValue(features);
        if (!arrValue || arrValue.length === 0) {
            return null;
        }

        const translated = niceSortInPlace(arrValue.map((msgid) => COUNTRY_MESSAGES[msgid]));

        return (
            <div className={styles.CountriesFeature}>
                {translated.join(', ')}
            </div>
        );
    }
}
